import { render } from "./AddObat.vue?vue&type=template&id=69bde6cc"
import script from "./AddObat.vue?vue&type=script&lang=js"
export * from "./AddObat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__